export const MAX_PASSWORD_LENGTH = 64;
